// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .add-member-form__form{} */

/* .add-member-form__box{} */

.add-member-form__box__container{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    /* gap: var( --grid-gap ); */
    grid-template-areas: "left left right";
    align-items: center;
}

.add-member__grid__left-col{
    grid-area: left;
    padding-block-start: var(--space-x3);
    padding-left: var(--space);
}
.add-member__grid__left-col__title{
    margin-bottom: var(--space) !important;
    font-weight: var(--font-regular) !important;
    font-size: var(--space);
}

.add-member__grid__right-col{
    grid-area: right;
    padding-block-start: calc(var(--space-x3) + var(--space-and-half));
}

.add-member__data{
    display: flex;
    justify-content: space-between;
    border-radius: 8px 0 0 8px;
    border: 1px solid var(--new-gray-background-color);
    padding-left: var(--space-and-half);
    background-color: var(--new-background-color);
    /* margin: var(--space-and-half) 0 0 0; */
    align-items: center;
}

.add-member__data__user{
    display: flex;
    align-items: center;
}

.add-member__data__user__photo{
    border-radius: 50%;
    /* background-color: turquoise; */
    width: calc((var(--space)/8)*20); /*52px*/
    height: calc((var(--space)/8)*20);
    margin: 0 var(--space-half-quarter) 0 0;
    display: flex;
    align-items: center;
}

.add-member__data__user__photo .icon-ball{
   color: var( --white-color );
   font-size: calc((var(--space-half))*4);/*48px;*/
   border-radius: 50%;
   padding: calc(var(--space)/4);/*4px;*/
}


.add-member__data__user__photo__img{
    border-radius: 50%;
    width: calc((var(--space)/9)*26);
    height: calc((var(--space)/9)*26);
}

.add-member__data__data{
    display: grid;
    justify-content: center;
}

.add-member__data__data__name{
    font-size: calc(var(--space) - 1px);
}

.add-member__data__data__username{
    color: var(--basic-gray-color);
    font-size: calc(var(--space) - 2px) ;
}

.add-member__data__delete{
    margin-right: var(--space);
}

.add-member__box__without-results{
    text-align: center;
    margin-top: var(--space-and-half);
    margin-bottom: var(--space-and-half)
}

.add-member__roles__data-select{
    display: flex;
    justify-content: center;
    padding-block-start: var(--space);
}

.add-member__roles{
    width: 100%;
    /* margin-left: var(--space-and-half); */
    margin-right: var(--space-and-half);
    margin-block-start: 0;
    font-size: var(--space-half-quarter);
    margin-bottom: 0px;
}

.add-member__roles .select-field-input{
    background-color: white;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 0 8px 8px 0;
    height: calc(var(--space-x3) - var(--space-quarter));
}

.add-member-form__box__container__two{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    gap: var( --grid-gap );
    grid-template-areas: "left right";
}

.add-member-form__box__container__two__grid__right-col{
    grid-area: right;
}

.add-member-form__box__container__two__grid__left-col{
    grid-area: left; 
}

.add-member__positions__number{
    width: 100%;
    margin-bottom: 0 !important;
    padding-right:var(--space);
}
.add-member__positions__number .input-field-input{
    background-color: white;
    border: 1px solid var(--new-gray-background-color);
}

.add-member__positions__positions{
    padding-left:var(--space) ;
    padding-top: var(--space-and-half);
    width: 100%;
}

.add-member__positions__positions .select-field-input{
    background-color: white;
    border: 1px solid var(--new-gray-background-color);
}

.add-member__positions__text .select-field-label{
    color: var(--primary-very-dark-color) !important;
    font-weight: var(--font-regular) !important;
}

.add-member__positions__number__text .input-field-label {
    color: var(--primary-very-dark-color) !important;
    font-weight: var(--font-regular) !important;
}

.add-member__grid__left-col .league-search-member-team-container .league-search-member-team-form__box .input-search__input {
    border-radius: 8px 0 0 8px;
}

.add-member__grid__left-col .league-search-member-team-container .league-search-member-team-form__box {
    padding-right: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/add-member-with-account-modal/AddMemberWithAccountModalComponent.styles.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B,4BAA4B;;AAE5B;IACI,aAAa;IACb,qCAAqC;IACrC,wBAAwB;IACxB,4BAA4B;IAC5B,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,0BAA0B;AAC9B;AACA;IACI,sCAAsC;IACtC,2CAA2C;IAC3C,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,kEAAkE;AACtE;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,kDAAkD;IAClD,mCAAmC;IACnC,6CAA6C;IAC7C,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,gCAAgC,EAAE,OAAO;IACzC,iCAAiC;IACjC,uCAAuC;IACvC,aAAa;IACb,mBAAmB;AACvB;;AAEA;GACG,2BAA2B;GAC3B,sCAAsC,CAAC,QAAQ;GAC/C,kBAAkB;GAClB,6BAA6B,CAAC,OAAO;AACxC;;;AAGA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;IACjC;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,mCAAmC;IACnC,qBAAqB;IACrB,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kDAAkD;IAClD,0BAA0B;IAC1B,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,wBAAwB;IACxB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,0BAA0B;AAC9B;AACA;IACI,uBAAuB;IACvB,kDAAkD;AACtD;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,kDAAkD;AACtD;;AAEA;IACI,gDAAgD;IAChD,2CAA2C;AAC/C;;AAEA;IACI,gDAAgD;IAChD,2CAA2C;AAC/C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["/* .add-member-form__form{} */\n\n/* .add-member-form__box{} */\n\n.add-member-form__box__container{\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-template-rows: auto;\n    /* gap: var( --grid-gap ); */\n    grid-template-areas: \"left left right\";\n    align-items: center;\n}\n\n.add-member__grid__left-col{\n    grid-area: left;\n    padding-block-start: var(--space-x3);\n    padding-left: var(--space);\n}\n.add-member__grid__left-col__title{\n    margin-bottom: var(--space) !important;\n    font-weight: var(--font-regular) !important;\n    font-size: var(--space);\n}\n\n.add-member__grid__right-col{\n    grid-area: right;\n    padding-block-start: calc(var(--space-x3) + var(--space-and-half));\n}\n\n.add-member__data{\n    display: flex;\n    justify-content: space-between;\n    border-radius: 8px 0 0 8px;\n    border: 1px solid var(--new-gray-background-color);\n    padding-left: var(--space-and-half);\n    background-color: var(--new-background-color);\n    /* margin: var(--space-and-half) 0 0 0; */\n    align-items: center;\n}\n\n.add-member__data__user{\n    display: flex;\n    align-items: center;\n}\n\n.add-member__data__user__photo{\n    border-radius: 50%;\n    /* background-color: turquoise; */\n    width: calc((var(--space)/8)*20); /*52px*/\n    height: calc((var(--space)/8)*20);\n    margin: 0 var(--space-half-quarter) 0 0;\n    display: flex;\n    align-items: center;\n}\n\n.add-member__data__user__photo .icon-ball{\n   color: var( --white-color );\n   font-size: calc((var(--space-half))*4);/*48px;*/\n   border-radius: 50%;\n   padding: calc(var(--space)/4);/*4px;*/\n}\n\n\n.add-member__data__user__photo__img{\n    border-radius: 50%;\n    width: calc((var(--space)/9)*26);\n    height: calc((var(--space)/9)*26);\n}\n\n.add-member__data__data{\n    display: grid;\n    justify-content: center;\n}\n\n.add-member__data__data__name{\n    font-size: calc(var(--space) - 1px);\n}\n\n.add-member__data__data__username{\n    color: var(--basic-gray-color);\n    font-size: calc(var(--space) - 2px) ;\n}\n\n.add-member__data__delete{\n    margin-right: var(--space);\n}\n\n.add-member__box__without-results{\n    text-align: center;\n    margin-top: var(--space-and-half);\n    margin-bottom: var(--space-and-half)\n}\n\n.add-member__roles__data-select{\n    display: flex;\n    justify-content: center;\n    padding-block-start: var(--space);\n}\n\n.add-member__roles{\n    width: 100%;\n    /* margin-left: var(--space-and-half); */\n    margin-right: var(--space-and-half);\n    margin-block-start: 0;\n    font-size: var(--space-half-quarter);\n    margin-bottom: 0px;\n}\n\n.add-member__roles .select-field-input{\n    background-color: white;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 0 8px 8px 0;\n    height: calc(var(--space-x3) - var(--space-quarter));\n}\n\n.add-member-form__box__container__two{\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: auto;\n    gap: var( --grid-gap );\n    grid-template-areas: \"left right\";\n}\n\n.add-member-form__box__container__two__grid__right-col{\n    grid-area: right;\n}\n\n.add-member-form__box__container__two__grid__left-col{\n    grid-area: left; \n}\n\n.add-member__positions__number{\n    width: 100%;\n    margin-bottom: 0 !important;\n    padding-right:var(--space);\n}\n.add-member__positions__number .input-field-input{\n    background-color: white;\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.add-member__positions__positions{\n    padding-left:var(--space) ;\n    padding-top: var(--space-and-half);\n    width: 100%;\n}\n\n.add-member__positions__positions .select-field-input{\n    background-color: white;\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.add-member__positions__text .select-field-label{\n    color: var(--primary-very-dark-color) !important;\n    font-weight: var(--font-regular) !important;\n}\n\n.add-member__positions__number__text .input-field-label {\n    color: var(--primary-very-dark-color) !important;\n    font-weight: var(--font-regular) !important;\n}\n\n.add-member__grid__left-col .league-search-member-team-container .league-search-member-team-form__box .input-search__input {\n    border-radius: 8px 0 0 8px;\n}\n\n.add-member__grid__left-col .league-search-member-team-container .league-search-member-team-form__box {\n    padding-right: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
